<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            提醒记录列表
        </div>
        <div style="padding: 20px;">
            <div style="float:right;">
                <el-select v-model="remindType" placeholder="请选择提醒类型" style="width:200px;margin-right:10px">
                    <el-option
                            v-for="item in typeValue"
                            :key="item[0]"
                            :label="item[1]"
                            :value="item[0]">
                    </el-option>
                </el-select>
                <el-select v-model="status" placeholder="请选择充值类型" style="width:200px;margin-right:10px">
                    <el-option
                            v-for="item in statusValue"
                            :key="item[0]"
                            :label="item[1]"
                            :value="item[0]">
                    </el-option>
                </el-select>
                <el-date-picker
                    ref="picker"
                    v-model="datetimerangeValue"
                    type="daterange"
                    :clearable='false'
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width:250px;margin:0 5px;">
                </el-date-picker>
                <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
            </div>
            <div style="clear: both;"></div>
            <div style="margin-top:10px">
                <template>

                    <el-table :data="tableData" v-loading="loading" :height="th" border style="width: 100%;">

                        <el-table-column
                                prop="remindType"
                                :formatter="remindTypes"
                                label="提醒类型">
                        </el-table-column>

                        <el-table-column prop="remarks" label="备注"></el-table-column>

                        <el-table-column prop="createTime" :formatter="timefilter" label="创建时间"></el-table-column>

                        <el-table-column
                                prop="Status"
                                :formatter="statusTitle"
                                label="状态">
                        </el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Page",
        data(){
            return{
                loading:true,
                showModalAdd:false,
                showModalEdit:false,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                remindType:-1,
                status:-1,
                typeValue:[[-1,'全部提醒类型'],[1,'老人生日提醒'],[2,'活动提醒'],[3,'消防安全提醒'],[4,'食品安全提醒'],[5,'安防安全提醒']],
                statusValue:[[-1,'全部状态'],[0,'未处理'],[1,'已处理']],
                datetimerangeValue:[]
            }
        },

        created(){
            const end= new Date();
            const start=new Date(end.getTime() - 1000 * 60 * 60 * 24 * 30);
            this.datetimerangeValue=[start, end];
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            timefilter(row){
                return timefilters(row.createTime)
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"RemindRecord/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        status:this.status,
                        remindType:this.remindType,
                        startTime:timefilters(this.datetimerangeValue[0]).slice(0,10),
                        endTime:timefilters(this.datetimerangeValue[1]).slice(0,10),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            remindTypes(row){
                if(row.remindType == 1){
                    return "老人生日提醒";
                }
                if(row.remindType == 2){
                    return "活动提醒";
                }
                if(row.remindType == 3){
                    return "消防安全提醒";
                }
                if(row.remindType == 4){
                    return "食品安全提醒";
                }
                if(row.remindType == 5){
                    return "安防安全提醒";
                }
                return "其它";
            },
            statusTitle(row){
                if(row.status == 0){
                    return "未处理";
                }
                if(row.status == 1){
                    return "已处理";
                }
                return "其它";
            },


        }
    }
</script>

<style scoped>

</style>